var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"5px 0"}},[_vm._v("系统版本 V1.0.0.1")])
}
var staticRenderFns = []

export { render, staticRenderFns }